import React, {useMemo} from "react";
import {useTranslation} from "react-i18next";
import {ColumnDef} from "@tanstack/react-table";
import {DataTable} from "@/lib/components/DataTable";
import {RequestsByCompanyDTO} from "@/api/data-contracts";
import {ReportI18N} from "@/translations";

interface RequestsByCompanyReportProps {
    data: RequestsByCompanyDTO[];
}

interface RequestsByCompanyRow extends RequestsByCompanyDTO {
    id: number;
}

/**
 * Report table showing request counts per requester company.
 */
const RequestsByCompanyReport: React.FC<RequestsByCompanyReportProps> = ({ data }) => {
    const { t } = useTranslation();

    const rows = useMemo<RequestsByCompanyRow[]>(
        () => data.map((item, index) => ({ ...item, id: index })),
        [data]
    );

    const columns = useMemo<ColumnDef<RequestsByCompanyRow>[]>(
        () => [
            {
                header: t(ReportI18N.page.column.company),
                accessorFn: (row) => row.companyName ?? "",
                id: "companyName"
            },
            {
                header: t(ReportI18N.page.column.count),
                accessorFn: (row) => row.requestCount ?? 0,
                id: "requestCount"
            }
        ],
        [t]
    );

    return <DataTable columns={columns} data={rows} noResultsValue="" striped maxHeight={940} />;
};

export default RequestsByCompanyReport;
